<template>
  <div class="bubble right txtleft">
    <slot></slot>
    <a class="small button btnPush" @click="goToLink">C'est parti !</a>
    <i class="bt_close fas fa-times-circle" @click="clear"></i>
  </div>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'
  import Bouton from '@/components/Bouton'

  export default {
    props: ['cta'],
    components: { Bouton },
    methods: {
      ...mapActions(['clearMessage']),
      clear () {
        this.clearMessage({ messageType: this.currentMessage.type })
      },
      goToLink () {
        this.clear()
        this.$router.push(this.cta)
      }
    },
    computed: {
      ...mapGetters(['currentMessage'])
    }
  }
</script>

<style scoped>

  .mascotte.consol {
    display: block;
    width: 100px;
    height: 80px;
    background: #fff;
    top: 230px;
    right: 0;
    border-radius: 50px 0 0 50px;
    position: fixed;
    z-index: 100;
  }
  .mascotte.consol.masque.off {
    right: -400px;
  }
  .mascotte.consol.masque {
    right: 0;
  }
  .mascotte.consol .bubble {
    left: -290px;
    width: 300px;
    font-size: 21px;
    line-height: 25px;
    bottom: 25px;
  }
  .mascotte.consol img {
    max-width: 80px;
    margin-left: 10px;
    margin-top: -20px;
  }

  .mascotte.consol.byebye {
    animation-name: messageoff;
    animation-duration: 0.8s;
    animation-delay: 0.2s;
    animation-iteration-count: 1;
    animation-fill-mode: forwards;
  }
  
  @keyframes messageoff {
    0% {
      right: -200px; 
    }
    100% {
      right: 0;
    }
  }

  .bubble .new {
      position: absolute;
      top: -28px;
      background: #e3e039;
      color: #414141;
      padding: 5px 25px 5px 10px;
      left: -20px;
      border-radius: 10px;
      border: 2px solid #7d7c13;
  }
  .bubble .new i {
      margin-right: 10px;
  }
  
  .bubble .new {
      position: absolute;
      top: -28px;
      background: #e3e039;
      color: #414141;
      padding: 5px 25px 5px 10px;
      left: -20px;
      border-radius: 10px;
      border: 2px solid #7d7c13;
  }
  .bubble .new i {
      margin-right: 10px;
  }
  
  
</style>
